import ConfigForm from "../../components/create/create-config-form"

export default function ConfigsPage() {
  return (
    <div className="min-h-screen">
      <div className="container mx-auto px-4 py-12">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl max-xl:text-3xl font-bold bg-gradient-to-r from-[var(--color-primary-500)] to-[var(--color-primary-400)] bg-clip-text text-transparent mb-4">
            Site Configuration
          </h1>
          <p className="text-sm max-xl:text-sm text-gray-600 max-w-2xl mx-auto">
            Manage your website's contact information and social media links.
          </p>
        </div>

        {/* Form Container */}
        <div className="max-w-3xl mx-auto">
          <ConfigForm />
        </div>
      </div>
    </div>
  )
}
